// extracted by mini-css-extract-plugin
module.exports = {"code":"Code_code__4wUjt","left":"Code_left__76Lxt","codeBtn":"Code_codeBtn__EASYS","timer":"Code_timer__CEc0b","close":"Code_close__Er7jX","line":"Code_line__9_08K"};